import { SET_SIDENAV } from '@/store/mutation_types';
import { CLEAR_SIDENAV, UPDATE_SIDENAV } from '@/store/action_types';

const sidenav = {
  state: {
    isCollapsed: false,
  },
  getters: {
    isCollapsed: (state: { isCollapsed: string }) => state.isCollapsed,
  },
  mutations: {
    [SET_SIDENAV]: (state: { isCollapsed: string }, payload: any) => {
      state.isCollapsed = payload;
    },
  },
  actions: {
    [CLEAR_SIDENAV]: ({ commit }: any) => {
      commit(SET_SIDENAV, null);
    },
    [UPDATE_SIDENAV]: ({ commit }: any, payload: any) => {
      commit(SET_SIDENAV, payload);
    },
  },
};

export default sidenav;
